// Default (empty) sales-data record used when adding a new Sales Data row.
export const EMPTY_SALES_DATA = {
  sales_org_id: '',
  dist_channel_id: '',
  plant_id: '',
  // Sales Org 1 fields
  sales_unit: '',
  min_order_qty: '',
  min_delivery_qty: '',
  cash_discount: false,
  // Sales Org 2 fields
  account_assignment_group: '',
  // Sales General/Plant fields
  availability_check: '',
  profit_center: '',
  transportation_group: '',
  loading_group: '',
  // ATP Lead Times
  loading_time: '',
  pick_pack_time: '',
};
